import React, { Component } from 'react';
class getPax extends Component {

  constructor(props){
     super(props);
     this.state = {
      pax:props.pax
     }
   }

   inputChangedHandler = (event) => {
       this.setState(
         {
           pax: event.target.value
         }
       )
   }
   setTeclado = (pax) => {
     if(pax ==="DEL"){
       pax="";
     }else{
       pax=this.state.pax+""+pax;
     }
     this.setState(
       {
         pax
       }
     )
   }
   
  render (){
    return (
       <div className="grid-cssversion_content_global cssversion_pw100 cssversion_ph100" >
         <div className="grid-cssversion_content_global cssversion_pw100 cssversion_ph100 cssversion_contentCenter">
         <div style={{"width":"100%","height":"100%","backgroundColor":"#00000000","display":"flex","flexDirection":"column","alignItems":"center"}}>
           <label style={{'color':'black'}}>Ingresar número de PAX's</label>
           <br/>
              <input className="css-cantidad-vendedor" placeholder="PAX" type="text" value={this.state.pax}  onChange={(event)=>this.inputChangedHandler(event)} />
             <div className="grid-container_teclado_vendedor" >
               <div className="div_uno"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(1)} >1</button></div>
               <div className="div_dos"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(2)} >2</button></div>
               <div className="div_tres"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(3)} >3</button></div>
               <div className="div_cuatro"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(4)} >4</button></div>
               <div className="div_cinco"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(5)} >5</button></div>
               <div className="div_seis"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(6)} >6</button></div>
               <div className="div_siete"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(7)} >7</button></div>
               <div className="div_ocho"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(8)} >8</button></div>
               <div className="div_nueve"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(9)} >9</button></div>
               <div className="div_cero"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(0)} >0</button></div>
               <div className="div_delete"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado("DEL")} >DEL</button></div>
               <div className="div_punto"></div>
               <div className="div_enter"><button className="btn_teclado_opcion_vendedor" onClick={ () => this.props.getRegresarActualizarPax(this.state.pax)} >GUARDAR</button></div>
               <div className="div_guardar"><button className="btn_teclado_opcion_vendedor" onClick={ () => this.props.getRegresar()}>SALIR</button></div>
             </div>
           </div>
         </div>
       </div>
    )
  }
  componentDidMount() {
  }
}
export default getPax;
